import { Flex } from '@/components';

const AnnouncementItem = ({
  title,
  onClick,
  // mainText,
}) => {
  return (
    <Flex
      align="center"
      direction="row"
      onClick={() => onClick()}
      className="announcement-item">
      <Flex inlineFlex><b>{title}</b></Flex>
    </Flex>
  );
};

export default AnnouncementItem;
